<template>
  <Card
    header="You will no longer receive a recurring report"
    :successIcon="true"
  >
    <img
      v-lazy="'/static/report/periodical_report.svg'"
      alt="no longer report image"
    />
    <button class="btn btn-primary" @click="onClick()">
      Set up a recurrent report
    </button>
  </Card>
</template>

<script>
import Card from './index';
import GenerateReport from '../GenerateReport';
export default {
  components: { Card, GenerateReport },
  methods: {
    onClick() {
      this.$emit('onButtonClick', true);
    }
  }
};
</script>

<style lang="scss" scoped></style>
